import styled from 'styled-components'
import {
  space,
  position,
  color,
  typography,
  border,
  layout,
  flexbox,
  shadow,
  grid,
} from 'styled-system'

export const StyledUSMap = styled.div`
  path {
    fill: #b4a06e;
    stroke: #afa8a5;
    cursor: pointer;
  }
  path:hover {
    fill: #8b0e04;
  }
  rect {
    cursor: pointer;
  }
  text {
    pointer-events: none;
  }
  rect:hover {
    fill: #8b0e04;
  }
  svg {
    max-width: 100%;
  }
`

export const StyledVideo = styled.video`
  ${space}
  ${position}
  ${color}
  ${typography}
  ${border}
  ${layout}
  ${flexbox}
  ${shadow}
`

export const PyramidStyle = styled.div`
  .st0 {
    fill: #8b241d;
  }
  .st1 {
    fill: #404041;
  }
  .st2 {
    fill: #58595b;
  }
  .st3 {
    fill: #707070;
  }
  .st4 {
    fill: #77787b;
  }
  .st5 {
    fill: #2b0e2b;
  }
  .st6 {
    fill: #3d173e;
  }
  .st7 {
    fill: #5a3464;
  }
  .st8 {
    opacity: 0.4;
  }
  .st9 {
    fill: #ffffff;
  }
  .st11 {
    font-size: 17.9992px;
  }
  .st12 {
    fill: #7f6846;
  }
  .st13 {
    fill: #bfa870;
  }
  .st14 {
    fill: #464646;
  }
  .st15 {
    fill: #2f2f2f;
  }
  .st16 {
    fill: #252525;
  }
  .st17 {
    fill: #8a1812;
  }
  .st18 {
    fill: #631105;
  }
  #newera {
    max-width: 725px;
  }
  .ph-row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .ph-vmiddle {
    align-items: center;
  }
  .pyr-col100 {
    width: 100%;
    padding: 0 15px;
  }
  .pyr-items {
    padding-top: 50px;
  }
  .pyr-col60 {
    width: 60%;
    padding: 0 15px;
    padding-right: 0;
  }
  .pyr-col40 {
    width: 40%;
    padding: 0 15px;
    padding-left: 0;
  }
  .step:hover .pyramid-link *,
  .step.active .pyramid-link * {
    fill: rgba(255, 255, 255, 1);
  }
  .pyramid-link * {
    fill: rgba(255, 255, 255, 0.4);
  }
  #info {
    position: relative;
  }
  #info div {
    position: absolute;
    left: 45rem;
    top: -20rem;
    width: 30rem;
    border: 1px solid gray;
    min-height: 20rem;
  }
  #info h3 {
    margin-top: 0;
  }
  #info p:last-child {
    margin-bottom: 0;
  }
  .box h3.purple {
    color: #5a3464;
    text-transform: uppercase;
    margin-top: 5px;
  }
  .two-col-row h3 {
    width: 50%;
    float: left;
    text-align: center;
  }
  #info > div {
    background-color: #f4f2f4;
    padding: 30px;
  }
  #info div a {
    color: #8b0e04;
  }
  .hide-content {
    display: none;
  }
  .sh-tab {
    cursor: pointer;
  }
  .sh-tab g path {
    fill: rgba(255, 255, 255, 1);
  }
  .sh-tab:hover g {
    opacity: 1;
  }
  .sh-tab:hover g path {
    opacity: 1;
    fill: rgba(255, 255, 255, 1);
  }
  .sh-tab[newattr='active'] g path,
  .sh-tab[newattr='active'] g {
    fill: rgba(255, 255, 255, 1);
    opacity: 1;
  }
  .gne-pyramid {
    width: 100%;
    height: auto;
  }
  p.links {
    font-style: italic !important;
  }
  .m-r {
    margin-right: 10px;
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 0%;
    padding: 12px 16px;
    transform: translate(0%, -50%);
  }
  .overlay {
    position: fixed;
    top: 10%;
    bottom: 0;
    left: 0;
    right: 0;
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;
  }
  .overlay:target {
    visibility: visible;
    opacity: 1;
  }
  .box {
    display: none;
  }
  .st7 {
    color: #ffffff;
  }

  /*Mobile popup style for prymid starts*/
  .modal-wrapper {
    align-items: center;
    color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    justify-content: center;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    transition: all 0.2s ease-in-out;
    visibility: hidden;
    width: 100%;
    z-index: 1000;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-wrapper p {
    color: #fff;
  }
  .modal-wrapper.visible {
    opacity: 1;
    visibility: visible;
  }
  .modal-window {
    background-color: #5a3464;
    border-radius: 5px;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
    padding: 20px;
    transform: scale(0.5);
    transition: 0.2s ease-in-out all;
  }
  .modal-wrapper.visible .modal-window {
    transform: scale(1);
    width: 95%;
  }
  .modal-header {
    color: #ffffff;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .close-modal-button {
    border: none;
    background-color: transparent;
    color: rgb(112, 112, 112);
    cursor: pointer;
    font-size: 1rem;
    padding: 0.2em;
  }
  .close-modal-button:hover {
    color: #ffffff;
  }
  .close-modal-button {
    color: #ffffff;
    text-shadow: 0 1px 0 #fff;
    font-weight: bold;
    line-height: 1;
    position: absolute;
    right: 15px;
    top: 15px;
    display: block;
    z-index: 5;
    opacity: 0.95;
    font-size: 32px;
  }
  .modal-wrapper h2 {
    font-size: 28px;
    text-transform: uppercase;
    margin: 20px 0 10px 0;
    color: #fff;
  }

  .modal-wrapper h3 {
    font-size: 18px;
    font-style: italic;
    margin: 0 0 25px 0;
    color: #fff;
  }

  .modal-wrapper a {
    color: #bfa870 !important;
    font-weight: bold;
  }
  /*Mobile popup style for prymid ends*/

  .button {
    display: inline-block;
    background-color: #8b0e04;
    color: #fff !important;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    padding: 10px 27px;
    width: 96%;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  /*Responsive style for prymid start*/
  @media (max-width: 1024px) {
    #info > div {
      zoom: 0.8;
    }
    #newera {
      zoom: 0.7;
    }
  }
  @media (max-width: 991px) {
    .pyramid-wrap .ph-vmiddle {
      align-items: flex-start;
    }
  }
  @media (max-width: 800px) {
    #info > div,
    #newera {
      zoom: 1;
    }
    .box {
      display: block !important;
      margin-bottom: 100px;
    }
    .pyr-items {
      padding-top: 50px;
    }
    .pyramid-wrap .ph-row.ph-vmiddle {
      flex-direction: column;
      display: none;
    }
    .pyr-col60,
    .pyr-col40 {
      width: 100%;
      padding: 0 15px;
    }
    .gne-pyramid {
      width: 500px;
      transform: scale(1.5);
      height: auto;
    }
    .btn-gold {
      background-color: #bfa870;
      color: #fff;
      letter-spacing: 2px;
      font-size: 18px;
    }
    .btn-block {
      height: 50px;
      text-transform: uppercase;
      white-space: normal;
      word-wrap: break-word;
      padding: 12px 0px;
      margin: 5px 0;
      display: block;
      width: 100%;
      text-align: center;
    }
    .btn-red {
      background-color: #8a1812;
      color: #fff;
      font-size: 14px;
      width: 50%;
      float: left;
      margin: 3px 0;
    }
    .btn-red2 {
      width: 49% !important;
      margin-left: 6px !important;
    }
    .btn-purple {
      background-color: #5a3464;
      color: #fff;
      font-size: 14px;
      line-height: 17px;
      width: 100%;
      text-align: center;
      padding: 15px 0;
      margin: 3px 0;
      text-transform: uppercase;
    }
    .btn-gray {
      background-color: #5f6062;
      color: #fff;
      letter-spacing: 2px;
      font-size: 18px;
      text-align: center;
      padding: 10px 0;
      width: 100%;
      line-height: 32px;
    }
    .button.disabled {
      line-height: 28px;
    }
    .button.disabled:hover {
      background-color: #8a1812 !important;
    }
    .m-r {
      margin-right: 1px !important;
    }
  }
  @media (max-width: 767px) {
    #content:last-child {
      margin-top: 0;
      z-index: -1;
    }
    .pyr-col100 p br {
      display: none;
    }
    .btn-gold {
      font-size: 14px;
    }
    .btn-block {
      line-height: 28px !important;
    }
    .btn-red {
      width: 48%;
    }
    .btn-gray {
      font-size: 14px;
    }
  }
  /*Responsive style for pyramid end*/
`
